function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import axios from "axios";
import { SETTINGS } from "../../settings";
export var base = "".concat(SETTINGS.apiDomain, "/api/v2");
// handler to reduce noise on case & switch
// want this function to return an action object {type: "type", place/filter: fitler}
// this is still a mess
export function runFilter(_x) {
  return _runFilter.apply(this, arguments);
}

function _runFilter() {
  _runFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(filter) {
    var _filter$name, _filter$name2;

    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.t0 = filter.type;
            _context4.next = _context4.t0 === "strat_name_concepts" ? 3 : _context4.t0 === "strat_name_orphans" ? 6 : _context4.t0 === "intervals" ? 9 : _context4.t0 === "lithology_classes" ? 12 : _context4.t0 === "lithology_types" ? 12 : _context4.t0 === "lithologies" ? 13 : _context4.t0 === "all_lithologies" ? 16 : _context4.t0 === "all_lithology_classes" ? 19 : _context4.t0 === "all_lithology_types" ? 19 : 22;
            break;

          case 3:
            _context4.next = 5;
            return stratNameConcepts(filter);

          case 5:
            return _context4.abrupt("return", _context4.sent);

          case 6:
            _context4.next = 8;
            return stratNameOrphans(filter);

          case 8:
            return _context4.abrupt("return", _context4.sent);

          case 9:
            _context4.next = 11;
            return fetchIntervalFilter(filter);

          case 11:
            return _context4.abrupt("return", _context4.sent);

          case 12:
            return _context4.abrupt("return", {
              category: "lithology",
              id: (_filter$name = filter.name) !== null && _filter$name !== void 0 ? _filter$name : filter.id,
              name: (_filter$name2 = filter.name) !== null && _filter$name2 !== void 0 ? _filter$name2 : filter.id,
              type: filter.type,
              legend_ids: []
            });

          case 13:
            _context4.next = 15;
            return fetchLithFilter(filter);

          case 15:
            return _context4.abrupt("return", _context4.sent);

          case 16:
            _context4.next = 18;
            return fetchAllLithsFilter(filter);

          case 18:
            return _context4.abrupt("return", _context4.sent);

          case 19:
            _context4.next = 21;
            return fetchAllLithTypes(filter);

          case 21:
            return _context4.abrupt("return", _context4.sent);

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _runFilter.apply(this, arguments);
}

export var FilterType;

(function (FilterType) {
  FilterType["StratNameConcepts"] = "strat_name_concepts";
  FilterType["StratNameOrphans"] = "strat_name_orphans";
  FilterType["Intervals"] = "intervals";
  FilterType["LithologyClasses"] = "lithology_classes";
  FilterType["LithologyTypes"] = "lithology_types";
  FilterType["Lithologies"] = "lithologies";
  FilterType["AllLithologies"] = "all_lithologies";
  FilterType["AllLithologyTypes"] = "all_lithology_types";
  FilterType["AllLithologyClasses"] = "all_lithology_classes";
  FilterType["Environments"] = "environments";
  FilterType["EnvironmentTypes"] = "environment_types";
  FilterType["EnvironmentClasses"] = "environment_classes";
})(FilterType || (FilterType = {}));

//case "strat_name_concepts"
export var stratNameConcepts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(filter) {
    var id, conceptUrl, conceptIdRes, f, mobileUrl, mobileRes, legend_ids;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = filter.id;
            conceptUrl = "".concat(base, "/defs/strat_name_concepts?concept_id=").concat(id);
            _context.next = 4;
            return axios.get(conceptUrl, {
              responseType: "json"
            });

          case 4:
            conceptIdRes = _context.sent;
            f = conceptIdRes.data.success.data[0];
            mobileUrl = "".concat(base, "/mobile/map_filter?concept_id=").concat(id);
            _context.next = 9;
            return axios.get(mobileUrl, {
              responseType: "json"
            });

          case 9:
            mobileRes = _context.sent;
            legend_ids = mobileRes.data;
            return _context.abrupt("return", {
              category: "strat_name",
              id: id,
              type: FilterType.StratNameConcepts,
              name: f.name,
              legend_ids: legend_ids
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function stratNameConcepts(_x2) {
    return _ref.apply(this, arguments);
  };
}();
//strat_name_orphans
export var stratNameOrphans = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(filter) {
    var id, params, url, res, f, mobileURl, mobileRes, legend_ids;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            id = filter.id;
            params = {
              strat_name_id: id
            };
            url = "".concat(base, "/defs/strat_names");
            _context2.next = 5;
            return axios.get(url, {
              params: params,
              responseType: "json"
            });

          case 5:
            res = _context2.sent;
            f = res.data.success.data[0];
            mobileURl = "".concat(base, "/mobile/map_filter");
            _context2.next = 10;
            return axios.get(mobileURl, {
              params: params,
              responseType: "json"
            });

          case 10:
            mobileRes = _context2.sent;
            legend_ids = mobileRes.data;
            return _context2.abrupt("return", {
              category: "strat_name",
              id: id,
              type: FilterType.StratNameOrphans,
              name: f.strat_name_long,
              legend_ids: legend_ids
            });

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function stratNameOrphans(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
// intervals
export var fetchIntervalFilter = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(filter) {
    var id, url, res, f;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            id = filter.id;
            url = "".concat(base, "/defs/intervals?int_id=").concat(id);
            _context3.next = 4;
            return axios.get(url, {
              responseType: "json"
            });

          case 4:
            res = _context3.sent;
            f = res.data.success.data[0];
            f.name = f.name;
            f.type = "intervals";
            f.category = "interval";
            f.id = id;
            return _context3.abrupt("return", f);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchIntervalFilter(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
/* Lithology classes and lithology types are filtered by name */

//case "lithologies":
function fetchLithFilter(_x5) {
  return _fetchLithFilter.apply(this, arguments);
}

function _fetchLithFilter() {
  _fetchLithFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(filter) {
    var id, url, res, f, mobileURl, mobileRes, legend_ids;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            id = filter.id;
            url = "".concat(base, "/defs/lithologies?lith_id=").concat(id);
            _context5.next = 4;
            return axios.get(url, {
              responseType: "json"
            });

          case 4:
            res = _context5.sent;
            f = res.data.success.data[0];
            mobileURl = "".concat(base, "/mobile/map_filter?lith_id=").concat(id);
            _context5.next = 9;
            return axios.get(mobileURl, {
              responseType: "json"
            });

          case 9:
            mobileRes = _context5.sent;
            legend_ids = mobileRes.data;
            return _context5.abrupt("return", {
              category: "lithology",
              id: id,
              type: FilterType.Lithologies,
              name: f.name,
              legend_ids: legend_ids
            });

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchLithFilter.apply(this, arguments);
}

//case "all_lithologies":
function fetchAllLithsFilter(_x6) {
  return _fetchAllLithsFilter.apply(this, arguments);
}

function _fetchAllLithsFilter() {
  _fetchAllLithsFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(filter) {
    var id, url, res, f, mobileURL, mobileRes, legend_ids;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            id = filter.id;
            url = "".concat(base, "/defs/lithologies?lith_id=").concat(id);
            _context6.next = 4;
            return axios.get(url, {
              responseType: "json"
            });

          case 4:
            res = _context6.sent;
            f = res.data.success.data[0];
            mobileURL = "".concat(base, "/mobile/map_filter?all_lith_id=").concat(id);
            _context6.next = 9;
            return axios.get(mobileURL, {
              responseType: "json"
            });

          case 9:
            mobileRes = _context6.sent;
            legend_ids = mobileRes.data;
            return _context6.abrupt("return", {
              category: "lithology",
              id: id,
              type: FilterType.AllLithologies,
              name: f.name,
              legend_ids: legend_ids
            });

          case 12:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _fetchAllLithsFilter.apply(this, arguments);
}

// case "all_lithology_classes":
//  case "all_lithology_types":
function fetchAllLithTypes(_x7) {
  return _fetchAllLithTypes.apply(this, arguments);
}

function _fetchAllLithTypes() {
  _fetchAllLithTypes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(filter) {
    var type, id, param, url, res, legend_ids;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            type = filter.type, id = filter.id;
            param = type === "all_lithology_classes" ? "all_lith_class" : "all_lith_type";
            url = "".concat(base, "/mobile/map_filter?").concat(param, "=").concat(id);
            _context7.next = 5;
            return axios.get(url, {
              responseType: "json"
            });

          case 5:
            res = _context7.sent;
            legend_ids = res.data;
            return _context7.abrupt("return", {
              category: "lithology",
              id: id,
              name: id,
              type: type,
              legend_ids: legend_ids
            });

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _fetchAllLithTypes.apply(this, arguments);
}